export default "__VITE_PUBLIC_ASSET__85d0e0c3__"